import React, { useEffect } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useI18n } from "@/contexts/I18nContext";

/**
 * Route wrapper that syncs I18n language with the URL prefix.
 * - Used on `/*` (SQ default) and `/en/*` (English) branches.
 * - If `fallback` is set, immediately redirects to that path (for legacy
 *   aliases like `/sq`, `/it`, `/de`, `/fr`).
 */
export default function LangGate({ lang, fallback }) {
  const { lang: current, setLang } = useI18n();

  useEffect(() => {
    if (current !== lang) setLang(lang);
  }, [lang, current, setLang]);

  if (fallback) return <Navigate to={fallback} replace />;
  return <Outlet />;
}
